//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  CatFlowChartModal,
  CatImage,
} from 'counselor-mobile-ui'
import { previewImages } from 'counselor-sdk'
import { createNamespacedHelpers } from 'vuex'
import { TYPE_NAMES } from '@/public/config/requestType'
import { STATUS } from '@/public/config/statusConf'
import GENDER from '@/public/config/genderConf'

const { mapMutations } = createNamespacedHelpers('chooseSelected')

export default {
  components: {
    CatFlowChartModal,

    CatImage,
  },

  filters: {
    reqtype (val) {
      return TYPE_NAMES[val] || '其他'
    },
    outStatusName (val) {
      return val ? '离校' : '否'
    },
  },

  props: {
    showTitle: Boolean,

    isDetail: {
      type: Boolean,
      default: false,
    },

    isShared: {
      type: Boolean,
      default: false,
    },

    info: {
      type: Object,
      default: () => ({}),
    },

    my: Boolean,

    approveNodes: {
      type: Array,
      default: () => ([]),
    },

    needApproval: {
      type: [
        Number,
        String,
      ],
      default: 1,
    },

    fields: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return { flowVisible: false }
  },

  computed: {
    lastOutWarning () {
      return !this.my && this.info.lastOut && this.info.gender === GENDER.FEMALE
    },

    outWarning () {
      return (
        !this.my && this.info.outStatus && this.info.gender === GENDER.FEMALE
      )
    },

    isPending () {
      return this.info.ownStatus && this.info.status === STATUS.PENDING
    },

    visibleLastOut () {
      return this.info.lastOut === true || this.info.lastOut === false
    },

    approveOptions () {
      const list = []
      const approveNodes = this.approveNodes || []

      approveNodes.forEach((el) => {
        list.push({
          list: el.approveNode.map((item) => {
            return {
              ...item,
              name: item.nodeName,
            }
          }),
        })
      })

      return list
    },

    approverName () {
      const approvers = []
      const infoApprovers = this.info?.approvers || []

      infoApprovers.forEach((it) => {
        if (it.level && it.handled && it.approver) {
          approvers.push(it.approver.userName)
        }
      })

      return approvers.join(',')
    },

    // 计算发起位置
    calcAddressConfig () {
      const location = (this.info || {}).applyLocation
      const locationType = (location || {}).locationType
      const address = (location || {}).address

      switch (locationType) {
        case 0:
          return {
            ad: address === '暂无地理位置' ? '查看位置' : address,
            style: {
              color: '#3399ff',
              cursor: 'pointer',
            },
          }
        case 1:
          return {
            ad: '未授权定位',
            style: { cursor: 'default' },
          }
        case 2:
          return {
            ad: '定位获取失败',
            style: { cursor: 'default' },
          }
        case 3:
          return {
            ad: 'V1.1.1版本前请假申请无需获取定位',
            style: { cursor: 'default' },
          }
        case 4:
          return {
            ad: 'PC端发起',
            style: { cursor: 'default' },
          }
      }
    },

    totalCCNum () {
      if (this.info.ccInfo) {
        return this.info.ccInfo.totalSize || 0
      } else {
        return 0
      }
    },

    allCheckList () {
      if (this.info.ccInfo) {
        return [
          ...this.info.ccInfo.teachers,
          ...this.info.ccInfo.students,
        ]
      } else {
        return []
      }
    },

    ccInfo () {
      return this.totalCCNum ? `已选择${this.totalCCNum}人<span style="color: #2D8CF0">查看 ></span>` : '无'
    },
  },

  methods: {
    ...mapMutations(['setDataList']),

    viewLocation () {
      const location = (this.info || {}).applyLocation
      const locationType = (location || {}).locationType
      const address = (location || {}).address
      const longitude = (location || {}).longitude
      const latitude = (location || {}).latitude

      if (locationType) {
        return false
      }

      this.$router.push(
        `/map/${longitude}/${latitude}/${encodeURI(address)}`
      )
    },

    preview (imageLists, currentIndex) {
      previewImages({
        imageLists,
        currentIndex,
        disableUrlCodec: true
      })
    },

    viewCCDetail () {
      if (this.totalCCNum === 0) {
        return
      }

      this.setDataList(this.allCheckList)
      this.$router.push({ path: '/chooseSelected' })
    },
  },
}
